import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Location } from 'history';

import { useTranslation } from 'app/lang';
import { addPersonalData } from 'app/lib/account/reducers/clientInfo/clientInfoReducer';

import { DISABLED_TITLE_STATUSES } from '../../constants';
import { listenStorage } from '../../utils/user-full-name-storage';

const NoFullNameLink = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const changeLocation = useCallback((location: Location): Location => {
    listenStorage((fullName) => {
      dispatch(addPersonalData(fullName));
    });

    return { ...location, pathname: '/personal/profile', search: '?fromBetSlip' };
  }, []);

  return (
    <Link to={changeLocation}>
      {t(DISABLED_TITLE_STATUSES.noFullName)}
    </Link>
  );
};

export default NoFullNameLink;
